export default __webpack_public_path__ + "static/media/robots2.1f843f98.jpg";